var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -2048 2055 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(1, -1)",
    d: "M1088 2044q96 0 185 -25t167 -71t142 -110t110 -142t71 -167t25 -185q0 -137 -52.5 -264.5t-149.5 -224.5l-837 -836l-90 90l836 837q79 79 122 182.5t43 215.5q0 117 -45.5 221t-123.5 182t-182 123.5t-221 45.5q-108 0 -190.5 -32.5t-152.5 -86t-134.5 -121.5 t-135.5 -140h421v-128h-640v640h128v-421q55 56 105.5 108.5t101 99t103 85t112 66t129 43t153.5 15.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.a259d739.svg";
export { ForwardRef as ReactComponent };